
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/8a3a8619d31942f95a593de8958f2ef8/d925ce72c51d6afc46e1204b8a69b068.png" 
                alt="BiviLinks" 
                className="h-10 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              La plataforma digital que conecta personas con proveedores de servicios. 
              Transforma tus conexiones en ingresos de forma simple y transparente.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="#inicio" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Inicio</a></li>
              <li><a href="#quienes-somos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Quiénes Somos</a></li>
              <li><a href="#como-funciona" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Cómo Funciona</a></li>
              <li><a href="#beneficios" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Beneficios</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Soporte</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Centro de Ayuda</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Términos de Uso</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Política de Privacidad</a></li>
              <li><a href="#contacto" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contacto</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-primary-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 BiviLinks. Todos los derechos reservados.
          </p>
          <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};
